const NUM_CHARS_FROM_LEFT = 8;
const NUM_CHARS_FROM_RIGHT = 4;

export const convertToEllipsizedText = (originalText: string) => {
    const initialPart = originalText.substring(0, NUM_CHARS_FROM_LEFT);
    const lastPart = originalText.substring(originalText.length - NUM_CHARS_FROM_RIGHT, originalText.length);
    return `${initialPart}...${lastPart}`;
};
